export default "__VITE_ASSET__Bol33NG4__"